import { render } from "./AccordionArrowIcon.vue?vue&type=template&id=5e7c23b8&scoped=true&ts=true"
import script from "./AccordionArrowIcon.vue?vue&type=script&lang=ts"
export * from "./AccordionArrowIcon.vue?vue&type=script&lang=ts"

import "./AccordionArrowIcon.vue?vue&type=style&index=0&id=5e7c23b8&scoped=true&lang=scss"

import exportComponent from "/srv/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e7c23b8"]])

export default __exports__